import { ISectionData, SectionRecord, sectionFromJSON } from "common/records/Section";
import { List, Record } from "immutable";

export const jobMenuFromJSON = (json: Partial<IJobMenuData>): JobMenuRecord => {
  const recordData: IJobMenuRecord = { ...(json as any) };

  recordData.sections = List((json.sections || []).map((section) => sectionFromJSON(section)));

  return new JobMenuRecord(recordData);
};

export interface IJobMenuData {
  sections: ISectionData[];
}

export interface IJobMenuRecord {
  sections: List<SectionRecord>;
}

export const defaultJobMenuProps: IJobMenuRecord = {
  sections: List(),
};

export class JobMenuRecord extends Record(defaultJobMenuProps) implements IJobMenuRecord {}
